module.exports = __webpack_public_path__ + "img/top_denwa_toumei.6b3e90f6.gif";